export default "__VITE_ASSET__91cc081c__"